module.exports = __webpack_public_path__ + "static/img/letterheadkpdn.369bdef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/letterheadkpdn.png
// module id = 6sTJ
// module chunks = 175